module.exports = __webpack_public_path__ + "static/media/addon.25082521.svg";